import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from '../../mutation-types';
import transactionApi from '../../../api/transaction';

const defaultState = () => ({
    transaction: {
        results: [],
        pagination: []
    },
    transactionOne: {
        transaction_total_price: 0
    },
    selectedBank: {},
    konfirmResponse:{
        code : '',
        data :{
            origin_name: '',
            origin_account: '',
            origin_number: '',
            origin_branch: '',
            origin_nominal: '',
            origin_note: '',
        }
    }
});

const state = defaultState();

const getters = {};

const mutations = {
    resetKonfirmResponse(state){
        let first = {
            code : '',
            data :{
                origin_name: '',
                origin_account: '',
                origin_number: '',
                origin_branch: '',
                origin_nominal: '',
                origin_note: '',
            }
        }
        state.konfirmResponse = Object.assign({}, state.konfirmResponse, first);
    },
    listTransaction(state, data) {
        state.transaction = Object.assign({}, state.transaction, data);
    },
    listTransactionOne(state, data) {
        state.transactionOne = Object.assign({}, state.transactionOne, data);
    },
    saveConfirmResponse(state, data){
        state.konfirmResponse = Object.assign({}, state.konfirmResponse, data);
    }

};

const actions = {
    getOneTransaction({ commit, dispatch }, value) {
        commit(PROGRESS_START, null, { root: true });
        if (value.auth) {
            transactionApi.detailMember(value.param).then(({ data: { data } }) => {
                commit('listTransactionOne', data);
                commit(PROGRESS_FINISH, null, { root: true });
            }).catch((err) => {
                const { data } = err.response;
                dispatch('errorHandler', data);
                commit(PROGRESS_FAIL, null, { root: true });
            });
        } else {
            transactionApi.detailPublic(value.param).then(({ data: { data } }) => {
                commit('listTransactionOne', data);
            }).catch((err) => {
                const { data } = err.response;
                dispatch('errorHandler', data);
                commit(PROGRESS_FAIL, null, { root: true });
            });
        }
    },
    getTransaction({ commit, dispatch }) {
        commit(PROGRESS_START, null, { root: true });
        transactionApi.Member().then(({ data: { data } }) => {
            commit('listTransaction', data);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    konfirmation({ commit }, value) {
        commit(PROGRESS_START, null, { root: true });
        if (value.auth) {
            transactionApi.transferMember(value.param).then((res) => {
                const data = res.data;
                commit('saveConfirmResponse', data)
                commit(PROGRESS_FINISH, null, { root: true });
            })
            .catch((err) => {
                const data = err.response.data;
                commit('saveConfirmResponse', data)
            });
        } else {
            transactionApi.transferPublic(value.param).then((res) => {
                const data = res.data;
                commit('saveConfirmResponse', data)
            })
            .catch((err) => {
                const data = err.response.data;
                commit('saveConfirmResponse', data)
            });
        }
    },
    errorHandler({ commit }, response) {
        commit('failed', { type: 'error', message: response.message });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,

};